import React, { Component } from 'react';
import service from '../../payment-partners/services/paymentPartnersService';

class SelectCeco extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ceco: this.props.ceco
        };

        this.handleChange = (event) => {
            const ceco = event.target.value;
            this.props.onSelectCecoChange(ceco);
            this.setState({ceco: ceco})
        };
    }

    render() {
        const { title, classname, label, disabledAll, cecos } = this.props;
        return (
            <div className={classname}>
                <label className="control-label" htmlFor="selectCeco">{label}</label>
                <select className="form-control" style={{ maxHeight: '30px' }} value={this.state.ceco} onChange={this.handleChange} title={title}>
                    <option value="0" disabled={disabledAll}>Todos</option>
                    {cecos.length > 0 ? cecos.map((local) => {
                        const ceco = `${local.numero}`;
                        return <option key={local.idLocal} value={ceco}>{ceco}</option>
                    }) : "Cargando..."}
                </select>
            </div>
        )
    }
}

export default SelectCeco;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/SelectCeco.jsx